export const CREDIT_REPORT_STATUS_RECEIVED = "Business Report Received";
export const CREDIT_REPORT_STATUS_ORDERED = "Business Report Ordered";
export const CREDIT_REPORT_STATUS_WAITING_DOCUMENTS = "Waiting Documents";
export const CREDIT_REPORT_STATUS_DROPPED = "Dropped";
export const CREDIT_REPORT_STATUS_UNDERLYING_STRUCTURE = "Underlying Structure";

// Values retained on existing opportunities before the backend picklist was
// standardized. They still need meaningful colors in the pipeline.
export const CREDIT_REPORT_STATUS_LEGACY_RECEIVED = "Credit Report Received";
export const CREDIT_REPORT_STATUS_LEGACY_ORDERED = "Credit Report Ordered";
export const CREDIT_REPORT_STATUS_SUBMITTED_TO_AMICORP = "Submitted to Amicorp";
export const CREDIT_REPORT_STATUS_ONBOARDED = "Onboarded";
export const CREDIT_REPORT_STATUS_REQUESTED = "Business Report Requested";
export const CREDIT_REPORT_STATUS_UNDER_REVIEW = "Under Review";

export const normalizeBusinessReportStatus = (status: string) => {
  if (status === CREDIT_REPORT_STATUS_LEGACY_RECEIVED) {
    return CREDIT_REPORT_STATUS_RECEIVED;
  }
  if (status === CREDIT_REPORT_STATUS_LEGACY_ORDERED) {
    return CREDIT_REPORT_STATUS_ORDERED;
  }
  return status;
};

export const getBusinessReportStatusLabel = (status?: string | null) => {
  if (!status) return undefined;
  return normalizeBusinessReportStatus(status).replace(/^Business Report\s+/, "");
};

/** Same values as `PRODUCTS` in `codes` — kept here so helpers stay Jest-safe. */
export const PRODUCT_KEY_FACTORING = "factoring";
export const PRODUCT_KEY_REVERSE_FACTORING = "reverse_factoring";

/** Compact alias when separators are stripped (e.g. "reversefactoring"). */
export const PRODUCT_KEY_REVERSE_FACTORING_COMPACT = "reversefactoring";

export const SUPPLIER_CREDIT_REPORT_COMPLETE = new Set<string>([
  CREDIT_REPORT_STATUS_RECEIVED,
  CREDIT_REPORT_STATUS_LEGACY_RECEIVED,
]);

export const BUYER_CREDIT_REPORT_COMPLETE = new Set<string>([
  CREDIT_REPORT_STATUS_RECEIVED,
  CREDIT_REPORT_STATUS_LEGACY_RECEIVED,
]);

// Green pipeline states follow the existing frontend pipeline progress rules.
// These are broader than report completion because some statuses indicate the
// report has moved to a later workflow stage.
export const SUPPLIER_CREDIT_REPORT_GREEN = new Set<string>([
  ...SUPPLIER_CREDIT_REPORT_COMPLETE,
  CREDIT_REPORT_STATUS_SUBMITTED_TO_AMICORP,
  CREDIT_REPORT_STATUS_ONBOARDED,
]);

export const BUYER_CREDIT_REPORT_GREEN = new Set<string>([
  ...BUYER_CREDIT_REPORT_COMPLETE,
  CREDIT_REPORT_STATUS_ONBOARDED,
  CREDIT_REPORT_STATUS_REQUESTED,
  CREDIT_REPORT_STATUS_UNDER_REVIEW,
]);

export const CREDIT_REPORT_IN_PROGRESS = new Set<string>([
  CREDIT_REPORT_STATUS_WAITING_DOCUMENTS,
  CREDIT_REPORT_STATUS_DROPPED,
  CREDIT_REPORT_STATUS_UNDERLYING_STRUCTURE,
  CREDIT_REPORT_STATUS_ORDERED,
  CREDIT_REPORT_STATUS_LEGACY_ORDERED,
  // Preserve compatibility with values recognized before picklist alignment.
  "waiting documents",
  "dropped",
  "underlying structure",
]);
